/** Trigger a browser download (or new tab) for a remote file URL. */
export function downloadUrl(url: string, filename?: string) {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.target = '_blank'
  anchor.rel = 'noopener'
  if (filename) anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}
